module.exports = __webpack_public_path__ + "static/media/400107_02.3be314ff.png";